<template>
  <div class="comment">
    <a-spin :spinning="isLoading">
      <CommentInputGroup
        :entity="entity"
        :placeholder="$t('okr.comment.commentPlaceholder')"
        @sent="getComments"
      />
      <CommentItem
        v-for="comment in comments"
        :key="comment.id"
        :entity="entity"
        :comment="comment"
        class="comment-item"
        @delete="getComments"
        @sent="getComments"
      />
    </a-spin>
  </div>
</template>

<script>
import { ref, toRaw } from 'vue'

import { getDownloadUrl } from '@/utils/upload'
import { getComments as getCommentsApi } from '@/graphql/comment'
import CommentInputGroup from './CommentInputGroup'
import CommentItem from './CommentItem'

export default {
  name: 'Comment',
  components: {
    CommentInputGroup,
    CommentItem
  },
  props: {
    entity: {
      type: Object,
      required: true
    }
  },
  setup (props) {
    const isLoading = ref(false)
    const comments = ref([])
    const id = toRaw(props.entity).id

    const requestParams = {}
    if (props.entity.type === 'objective') {
      requestParams.objectiveId = id
    } else {
      requestParams.keyResultId = id
    }

    function getComments () {
      isLoading.value = true
      comments.value = []
      getCommentsApi(requestParams)
        .then(res => {
          comments.value = res.map(comment => ({
            ...comment,
            attachmentIds: comment.attachmentIds.map(attachment => ({
              ...attachment,
              url: getDownloadUrl(attachment.id)
            }))
          })).reverse()
          isLoading.value = false
        })
    }

    getComments()

    return {
      isLoading,
      comments,
      getComments
    }
  }
}
</script>

<style lang="less" scoped>
.comment {
  margin: -12px 16px -12px 4px;
  padding: 8px 12px;
  background-color: #FAFBFF;
  font-weight: normal;
  text-align: left;
}
</style>
